
import { AssetPreviewTabsUserController } from './asset-preview-tabs-user.controller'

function assetPreviewTabsUser () {
  return {
    restrict: 'E',
    scope: {
      template: '<',
      location: '<',
      previewFlags: '=',
      contextData: '<',
      task: '<'
    },
    templateUrl: '/core/directives/asset-preview-tabs-user/asset-preview-tabs-user.html?$$REVISION$$',
    controller: AssetPreviewTabsUserController
  }
}
export { assetPreviewTabsUser }
